// Density preference. Sets `data-density` on <html> so the CSS token layer
// (tokens.css) tightens table cell padding in compacta mode. Built on the
// shared createPreference primitive; the named exports below are the stable
// public surface (consumed by useDensity, src/index.jsx and the lib barrel).
//
// NOTE: DensityToggle was intentionally removed from TableToolbar ("wasn't part
// of the original recepthor app"). This module re-adds the pref backend for the
// Personalización settings panel per the prototype. A human should confirm
// whether the per-table density effect is desired.
import { createPreference } from './preference';

const pref = createPreference('rec:density', {
  fallback: 'comoda',
  valid: ['comoda', 'compacta'],
  applyAttr: 'density',
});

export const densityPref = pref;
export const initDensity = pref.init;
export const setDensity = pref.set;
